/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

export const VerticalDivider = (): JSX.Element => {
  return <div className="ai-vertical-divider"></div>;
};
